"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _SelectedActions = require("./SelectedActions");

var initialState = {
  selectedQuestion: null,
  selectedAnswer: null,
  showProps: false
};

var SelectedQuestiontReducer = function SelectedQuestiontReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case _SelectedActions.SET_SELECTED_QUESTION:
      return (0, _extends2["default"])({}, state, {
        selectedQuestion: action.selectedQuestionPayload,
        selectedAnswer: action.selectedAnswerPayload,
        showProps: true
      });

    case _SelectedActions.UNSELECT_QUESTION:
      return (0, _extends2["default"])({}, state, {
        selectedQuestion: null,
        selectedAnswer: null,
        showProps: false
      });

    case _SelectedActions.HIGHLIGHT_QUESTION:
      return (0, _extends2["default"])({}, state, {
        selectedQuestion: action.payload,
        showProps: false
      });

    default:
      return state;
  }
};

var _default = exports["default"] = SelectedQuestiontReducer;